// extracted by mini-css-extract-plugin
export default {"toggle-outer":"bplcCFXz","toggle-container":"LNMNMpHF","toggle":"O6PFcFP9","slider":"YMUhY1Ti","round":"ITOwJHV5"};